import Api from './index';

export default class Marketplace {

    static async getRefs() {
        return await Api.getData({
            action: 'marketplace.getRefs',
        });
    };

    static async buyGet(payload: any) {
        return await Api.getData({
            action: 'marketplace.buy.get',
            payload,
        });
    };

    static async buyBotConfiguration(payload: any) {
        return await Api.getData({
            action: 'marketplace.buy.buyConfiguration',
            payload,
        });
    };

    static async getFullInfoForBuy(payload: any) {
        return await Api.getData({
            action: 'marketplace.buy.getFullInfo',
            payload,
        });
    };

    static async sellGet(payload: any) {
        return await Api.getData({
            action: 'marketplace.sell.get',
            payload,
        });
    };

    static async removeFromMarketplace(id: (number | string)) {
        return await Api.getData({
            action: 'marketplace.sell.removeFromMarketplace',
            payload: { id },
        });
    };

    static async getFullInfoForSell(id: (number | string)) {
        return await Api.getData({
            action: 'marketplace.sell.getFullInfo',
            payload: { id },
        });
    };

    static async sellBotConfiguration(payload: any) {
        return await Api.getData({
            action: 'marketplace.sell.sellConfiguration',
            payload,
        });
    };

    static async mentorshipGet(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.mentors.get',
            payload,
        });
    };

    static async requestMentorship(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.mentors.requestMentorship',
            payload,
        });
    };

    static async myMentorsGet(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.myMentors.get',
            payload,
        });
    };

    static async mentorshipDoneFromMentee(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.myMentors.mentorshipDone',
            payload,
        });
    };

    static async iMentor(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.iMentor.get',
            payload,
        });
    };

    static async confirmMentorship(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.iMentor.confirmMentorship',
            payload,
        });
    };

    static async mentorshipDoneFromMentor(payload: any) {
        return await Api.getData({
            action: 'marketplace.mentorship.iMentor.mentorshipDone',
            payload,
        });
    };

    static async getMySignals(pager: any) {
        return await Api.getData({
            action: 'marketplace.signals.my.get',
            payload: { pager },
        });
    };

    static async getAvailSignals(pager: any) {
        return await Api.getData({
            action: 'marketplace.signals.avail.get',
            payload: { pager },
        });
    };

    static async getSignalsDetails(pager: any) {
        return await Api.getData({
            action: 'marketplace.signals.details.get',
            payload: { pager },
        });
    };

    static async signalsAvailBuy(id: (number | string)) {
        return await Api.getData({
            action: 'marketplace.signals.avail.buy',
            payload: { id },
        });
    };

    static async signalsMyRebill(id: (number | string)) {
        return await Api.getData({
            action: 'marketplace.signals.my.rebill',
            payload: { id },
        });
    };

    static async dashboardGet(payload: any) {
        return await Api.getData({
            action: 'marketplace.dashboard.get',
            payload,
        });
    };
}